import React from 'react';
import { IconProps } from '../types';

export const PresenceIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            d="M7.52796 25.4721L8.50042 27.4462C8.82219 28.1671 8.49864 29.0115 7.77775 29.3333C7.05686 29.6551 6.21242 29.3315 5.89064 28.6107L3.17773 22.7565"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M14.6667 26L7.5556 22.75H4.00004C2.52715 22.75 1.33337 21.5189 1.33337 20C1.33337 18.4811 2.52715 17.25 4.00004 17.25H7.5556L14.6667 14V26Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M29.3334 10V5.99999C29.3334 4.52724 28.1395 3.33333 26.6667 3.33333H4.00004C2.52728 3.33333 1.33337 4.52724 1.33337 5.99999V14"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M5.33333 8.66667C6.06971 8.66667 6.66667 8.06971 6.66667 7.33333C6.66667 6.59695 6.06971 6 5.33333 6C4.59695 6 4 6.59695 4 7.33333C4 8.06971 4.59695 8.66667 5.33333 8.66667Z"
            fill={color}
        />
        <path
            d="M9.33333 8.66667C10.0697 8.66667 10.6667 8.06971 10.6667 7.33333C10.6667 6.59695 10.0697 6 9.33333 6C8.59695 6 8 6.59695 8 7.33333C8 8.06971 8.59695 8.66667 9.33333 8.66667Z"
            fill={color}
        />
        <path
            d="M29.3333 28.6667H21.3333C20.5973 28.6667 20 28.0693 20 27.3333V11.3333C20 10.5973 20.5973 10 21.3333 10H29.3333C30.0693 10 30.6667 10.5973 30.6667 11.3333V27.3333C30.6667 28.0693 30.0693 28.6667 29.3333 28.6667Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path d="M20 23.3333H30.6667" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
);
